import { getFormattedEquipmentTypes } from "../../requests/type-requests";
import { DateFormats } from "../constants/securspace-constants";
import moment, { Moment } from 'moment';
import { InventoryActivityReportViewVO } from "../../types/model/valueObject/InventoryActivityReportViewVO";

const headerCells = [
  {id: 'activity', label: 'Activity'},
  {id: 'activityDate', label: 'Date'},
  {id: 'containerNumber', label: 'Container'},
  {id: 'trailerNumber', label: 'Trailer'},
  {id: 'chassisNumber', label: 'Chassis'},
  {id: 'truckLicensePlateNumber', label: 'Truck License Plate Number'},
  {id: 'chassisLicensePlateNumber', label: 'Chassis License #'},
  {id: 'assetSize', label: 'Size'},
  {id: 'driverFirstName', label: 'First Name (Driver)'},
  {id: 'driverLastName', label: 'Last Name (Driver)'},
  {id: 'driverLicenseNumber', label: 'License (Driver)'},
  {id: 'sealNumber', label: 'Seal'},
  {id: 'assetType', label: 'Type'},
  {id: 'orderNumber', label: 'Booking'},
  {id: 'locationName', label: 'Location'},
  {id: 'supplierName', label: 'Supplier'},
  {id: 'currentInventory', label: 'Inventory'},
  {id: 'correctionStatus', label: 'Correction Status'},
  {id: 'notes', label: 'Notes'},
  {id: 'scacCode', label: 'SCAC Code'}
];

const filterBySelectOption = (snackbarShowMessage: any) => [
  {
    label: "Equipment Type",
    value: "",
    name: "equipmentType",
    option: getFormattedEquipmentTypes(snackbarShowMessage)
  }
];

const sortByOptions: {label: string, value: string}[] = [
  {label: 'Activity', value: 'ACTIVITY'},
  {label: 'Activity Date', value: 'ACTIVITY_DATE'},
  {label: 'Container', value: 'CONTAINER_NUMBER'},
  {label: 'Trailer', value: 'TRAILER_NUMBER'},
  {label: 'Chassis', value: 'CHASSIS_NUMBER'},
  {label: 'Chassis License #', value: 'CHASSIS_LICENSE_PLATE_NUMBER'},
  {label: 'Size', value: 'ASSET_SIZE'},
  {label: 'First Name (Driver)', value: 'DRIVER_FIRST_NAME'},
  {label: 'Last Name (Driver)', value: 'DRIVER_LAST_NAME'},
  {label: 'License (Driver)', value: 'DRIVER_LICENSE_NUMBER'},
  {label: 'Seal', value: 'SEAL_NUMBER'},
  {label: 'Type', value: 'ASSET_TYPE'},
  {label: 'Booking', value: 'ORDER_NUMBER'},
  {label: 'Location', value: 'LOCATION_NAME'},
  {label: 'Partner', value: 'SUPPLIER_NAME'},
  {label: 'Inventory', value: 'CURRENT_INVENTORY'}
];

const formatDate = (date: string | Moment) => moment(date).format(DateFormats.DATE);

const filterTypes = {START_DATE: 'startDate', END_DATE: 'endDate', LOCATION: 'location', BOOKING_NUMBER: 'bookingNumber', EQUIPMENT_NUMBER: 'equipmentNumber', ASSET_TYPE: 'assetType', BUYER: 'buyer'}

const dialogTypes = {EDIT: "EDIT", MOVE: "MOVE", DELETE: "DELETE"};

export type dialogTypesKeys = "EDIT" | "DELETE" | "MOVE"

export interface ActionInterchange {
  id: string;
  containerNumber: string;
  chassisNumber: string;
  chassisLicensePlateNumber: string;
  sealNumber: string;
  firstName: string;
  lastName: string;
  trailerNumber: string;
  licenseNumber: string;
  truckLicensePlate: string;
  scacCode: string;
  notes: string;
  assetType: string;
  assetSize: string;
  eventDate: string;
  eventType: string;
}

export type DialogAction = ((actionItem: any, orderNumber?: any) => void) | (() => void);

export interface InterchangeOpenDialog {
  open: boolean;
  type: dialogTypesKeys;
  action: DialogAction;
}

export interface DialogProps {
  open: boolean;
  interchange: InventoryActivityReportViewVO;
  onAction: DialogAction;
  onClose: () => void;
  account?: {loggedInUsername: string};
  snackbarShowMessage?: (message: Object, severity: String) => void
}

export {
  headerCells,
  filterBySelectOption,
  sortByOptions,
  formatDate,
  filterTypes,
  dialogTypes
}